<template>
  <div style="padding: 20px">
    <component :is="component" />
  </div>
</template>

<script>
export default {
  name: "DynamicContent",
  props: {
    component: {
      type: Object,
      required: true,
    },
  },
};
</script>
